export default __webpack_public_path__ + "static/media/FlyingEagle.3a899a68.jpg";